// extracted by mini-css-extract-plugin
export default {"contenedorPrincipal":"faq_contenedorPrincipal__kxTFK","contAccordion":"faq_contAccordion__GK0aB","accordionItem":"faq_accordionItem__faA2u"};